import { SHORT_MONTHS } from './constants';

export const formatUTCDate = (date) => {
  const dateObject = new Date(date);
  const day = dateObject.getUTCDate();
  let hours = dateObject.getUTCHours();
  let minutes = dateObject.getUTCMinutes();

  if (hours < 10) {
    hours = `0${hours}`;
  }

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  const currentDate = new Date();
  if (
    day === currentDate.getUTCDate() &&
    dateObject.getUTCMonth() === currentDate.getUTCMonth() &&
    dateObject.getUTCFullYear() === currentDate.getUTCFullYear()
  ) {
    return `Today at ${hours}:${minutes}`;
  }

  if (
    day === currentDate.getUTCDate() - 1 &&
    dateObject.getUTCMonth() === currentDate.getUTCMonth() &&
    dateObject.getUTCFullYear() === currentDate.getUTCFullYear()
  ) {
    return `Yesterday at ${hours}:${minutes}`;
  }

  const month = SHORT_MONTHS[dateObject.getUTCMonth()];

  return `${day} ${month} at ${hours}:${minutes}`;
};

export const formatDate = (date) => {
  const dateObject = new Date(date);
  const day = dateObject.getDate();
  let hours = dateObject.getHours();
  let minutes = dateObject.getMinutes();

  if (hours < 10) {
    hours = `0${hours}`;
  }

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  const currentDate = new Date();
  if (
    day === currentDate.getDate() &&
    dateObject.getMonth() === currentDate.getMonth() &&
    dateObject.getFullYear() === currentDate.getFullYear()
  ) {
    return `Today at ${hours}:${minutes}`;
  }

  if (
    day === currentDate.getDate() - 1 &&
    dateObject.getMonth() === currentDate.getMonth() &&
    dateObject.getFullYear() === currentDate.getFullYear()
  ) {
    return `Yesterday at ${hours}:${minutes}`;
  }

  const month = SHORT_MONTHS[dateObject.getMonth()];

  return `${day} ${month} at ${hours}:${minutes}`;
};
